
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/landing/ygo-burst-protocol",
      function () {
        return require("private-next-pages/landing/ygo-burst-protocol.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/landing/ygo-burst-protocol"])
      });
    }
  